import React from 'react';
import { WHITE_LABEL_ACCENT_COLOR } from '../lib/white-label';

const css = `
  @keyframes ldio-8k0cpt46k2c {
    0% { transform: rotate(0deg) }
    50% { transform: rotate(180deg) }
    100% { transform: rotate(360deg) }
  }
  .ldio-8k0cpt46k2c div {
    position: absolute;
    animation: ldio-8k0cpt46k2c 1s linear infinite;
    width: 160px;
    height: 160px;
    top: 20px;
    left: 20px;
    border-radius: 50%;
    transform-origin: 80px 82px;
  }
  .loadingio-spinner-eclipse-lm3o6umaoe {
    width: 200px;
    height: 200px;
    display: inline-block;
    overflow: hidden;
    background: #ffffff;
  }
  .ldio-8k0cpt46k2c {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }
  .ldio-8k0cpt46k2c div { box-sizing: content-box; }
`;

const Loading = () => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '20% auto',
        zIndex: 20,
      }}
    >
      <div className="loadingio-spinner-eclipse-lm3o6umaoe">
        <div className="ldio-8k0cpt46k2c">
          <div
            style={{
              boxShadow: `0 4px 0 0 ${WHITE_LABEL_ACCENT_COLOR}`,
            }}
          ></div>
        </div>
      </div>
      <style type="text/css">{css}</style>
      {/* <Lottie
        animationData={animationData}
        play
        style={{ height: 250, width: 250 }}
      /> */}
    </div>
  );
};

export default Loading;
